<template>
  <v-dialog persistent v-model="dialog" width="500">
    <template v-slot:activator="{ on, attrs }">
      <span v-bind="attrs" v-on="on">
        <slot />
      </span>
    </template>
    <v-card>
      <v-card-title class="text-h5 red lighten-3">
        <span>Delete client : {{ client.clientName }}</span>
        <v-spacer></v-spacer>
        <v-btn icon @click="dialog = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <p class="font-weight-light body-1 ma-5">
          Do you really want to delete client
          <strong>{{ client.clientName }}</strong> from container
          <strong>{{ container }}</strong> of storage
          <strong>{{ storage }}</strong> and all its clients ?
        </p>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text color="orange" @click="confirm">
          Confirm
        </v-btn>
        <v-btn color="red" text @click="dialog = false">
          Cancel
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'

const { mapActions } = createNamespacedHelpers('storage')
export default {
  name: 'ClientConfirmDelete',
  props: {
    client: {
      type: Object,
      required: true
    },
    storage: {
      type: String,
      required: true
    },
    container: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      dialog: false
    }
  },
  methods: {
    ...mapActions(['deleteClient']),
    async confirm() {
      try {
        await this.deleteClient({
          container: this.container,
          storage: this.storage,
          ...this.client
        })
        this.dialog = false
      } catch (err) {
        this.dialog = false
      }
    }
  }
}
</script>

<style></style>
